/**
 * @name square-sparkles
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTVINyIgLz4KICA8cGF0aCBkPSJNMTUuNDEgMi40OWEuNi42IDAgMDExLjE4IDBsLjYzIDMuMzM0YTEuMiAxLjIgMCAwMC45NTYuOTU1bDMuMzM0LjYzMWEuNi42IDAgMDEwIDEuMThsLTMuMzM0LjYzYTEuMiAxLjIgMCAwMC0uOTU1Ljk1NmwtLjYzMSAzLjMzNGEuNi42IDAgMDEtMS4xOCAwbC0uNjMtMy4zMzRhMS4yIDEuMiAwIDAwLS45NTYtLjk1NUwxMC40OSA4LjU5YS42LjYgMCAwMTAtMS4xOGwzLjMzNC0uNjNhMS4yIDEuMiAwIDAwLjk1NS0uOTU2eiIgLz4KICA8cGF0aCBkPSJNMjEgMTN2NmEyIDIgMCAwMS0yIDJINWEyIDIgMCAwMS0yLTJWNWEyIDIgMCAwMTItMmg2IiAvPgogIDxwYXRoIGQ9Ik05IDEzdjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/square-sparkles
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const SquareSparkles: string = `
<svg
  class="lucide lucide-square-sparkles"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M11 15H7" />
  <path d="M15.41 2.49a.6.6 0 011.18 0l.63 3.334a1.2 1.2 0 00.956.955l3.334.631a.6.6 0 010 1.18l-3.334.63a1.2 1.2 0 00-.955.956l-.631 3.334a.6.6 0 01-1.18 0l-.63-3.334a1.2 1.2 0 00-.956-.955L10.49 8.59a.6.6 0 010-1.18l3.334-.63a1.2 1.2 0 00.955-.956z" />
  <path d="M21 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h6" />
  <path d="M9 13v4" />
</svg>
`;

export default SquareSparkles;
